import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

export interface ISesion {
  id: number;
  usuario_id: number;
  nombre_completo: string;
  email: string;
  empresa_id: number;
  device_name: string;
  browser: string;
  operating_system: string;
  ip: string;
  is_active: boolean;
  last_activity: string | null;
  created_at: string;
  revoked_at: string | null;
}

export interface IMetricasSesion {
  sesiones_activas: number;
  usuarios_conectados: number;
  dispositivos_registrados: number;
  sesiones_revocadas_hoy: number;
}

export interface ISesionesResponse {
  data: ISesion[];
  total: number;
}

@Injectable({
  providedIn: 'root',
})
export class SesionApiService extends BaseHttpService {
  private base = `${environment.apiUrl}${environment.apiPreFix}/usuario`;

  obtenerMisSesiones() {
    return this.withLoader(this.httpClient.get<ISesion[]>(`${this.base}/mis-sesiones`));
  }

  cerrarMiSesion(sessionId: number) {
    return this.withLoader(this.httpClient.delete(`${this.base}/mis-sesiones/${sessionId}`));
  }

  cerrarOtrasSesiones(exceptSessionId?: number) {
    const params =
      exceptSessionId !== undefined
        ? new HttpParams().set('except', String(exceptSessionId))
        : undefined;
    return this.withLoader(this.httpClient.delete(`${this.base}/mis-sesiones`, { params }));
  }

  obtenerSesionesEmpresa(filtros: Record<string, string | number | undefined>) {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(filtros)) {
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, String(value));
      }
    }
    return this.withLoader(this.httpClient.get<ISesionesResponse>(`${this.base}/sesiones`, { params }));
  }

  obtenerSesionesUsuario(userId: number) {
    return this.withLoader(this.httpClient.get<ISesion[]>(`${this.base}/${userId}/sesiones`));
  }

  revocarSesion(userId: number, sessionId: number) {
    return this.withLoader(this.httpClient.delete(`${this.base}/${userId}/sesiones/${sessionId}`));
  }

  revocarTodasSesiones(userId: number) {
    return this.withLoader(this.httpClient.delete(`${this.base}/${userId}/sesiones`));
  }

  obtenerMetricas() {
    return this.withLoader(this.httpClient.get<IMetricasSesion>(`${this.base}/sesiones/metricas`));
  }

  cerrarTodasSesiones() {
    return this.withLoader(
      this.httpClient.post(
        `${environment.apiUrl}${environment.apiPreFix}/auth/v2/cerrar-todas-sesiones`,
        {},
      ),
    );
  }
}
